const assertContextScope = <T>(context: T, name: string, hookName: string) => {
  if (!context) {
    throw new Error(`${hookName} should be used within ${name} scope`);
  }
};

export { assertContextScope };
